// GeoComm content hosts the issued indoor maps token can authenticate against.
// content-test/content-dev return 401, surfaced as CORS, so we never load them.
export const ALLOWED_GEOCOMM_TILE_HOSTS = ['content.geocomm.cloud'];

export const isAllowedGeoCommTileUrl = url => {
  try {
    return ALLOWED_GEOCOMM_TILE_HOSTS.includes(new URL(url).hostname);
  } catch {
    return false;
  }
};

// Esri interceptor url matcher, anchored to the same allowlist so the Bearer
// token is only attached to hosts we actually load tiles from.
export const GEOCOMM_TILE_INTERCEPTOR_URLS = ALLOWED_GEOCOMM_TILE_HOSTS.map(
  host => `https://${host}/indoor/v1/buildinglocations`,
);
